'use client';

import { Resource } from 'i18next';
import { memo, PropsWithChildren, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';

import { initTranslationsSync } from '@/i18n';

interface TranslationProviderProps {
  locale: string;
  resources: Resource;
}

export const TranslationProvider = memo<
  PropsWithChildren<TranslationProviderProps>
>(({ children, locale, resources }) => {
  const i18n = useMemo(
    () => initTranslationsSync(locale, resources),
    [locale, resources]
  );

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
});

TranslationProvider.displayName = 'TranslationProvider';
